import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import moment from "moment";
import Sidebar from "../../../../partials/aside/Sidebar";
import StepsAddCampaigns from "../../StepsAddCampaigns";
import validateFormAddCampaign from "../../../../../validtions/forms/campaign/banner/add";
import httpService from "../../../../../services/httpServices/httpServices";
import TypeGroupCampaign from "../../TypeGroupCampaign";
import helperNumber from "./../../../../../helpers/numbers";
import helperTime from "./../../../../../helpers/time";
import helperSpinner from "../../../../../helpers/spinner";
import messagesCampaignBannerSimple from "../../../../../messages/campaign/banner/simple";
import typeAmount from "../../../discount/campaign-banner/type-amount";
import TitleBar from "../../../../partials/content/TitleBar";
import { Link } from "react-router-dom";

function AddBannerSimpleCampaign({ charge }) {
  const history = useHistory();
  const [tagCategories, setTagCategories] = useState(<></>);
  const [categorySelected, setCategorySelected] = useState(null);
  const [campaignDays, setCampaignDays] = useState(0);

  const [fillPositions, setFillPositions] = useState([]);

  const [priceEachDay, setPriceEachDay] = useState(0);
  const [campaignPrice, setCampaignPrice] = useState(0);
  const [countPositions, setCountPositions] = useState(0);

  const [priceEachDayWithDiscount, setPriceEachDayWithDiscount] = useState(0);
  const [campaignPriceWithDiscount, setCampaignPriceWithDiscount] = useState(0);

  const [campaignDepositPrice, setCampaignDepositPrice] = useState(0);
  const [
    campaignDepositPriceWithDiscount,
    setCampaignDepositPriceWithDiscount,
  ] = useState(0);

  const [disableAddCampaignButton, setDisableAddCampaignButton] =
    useState(true);
  const [message, setMessage] = useState();
  const [messageDiscount, setMessageDiscount] = useState();
  const [discount, setDiscount] = useState(null);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  let messageDiscountTag;
  if (messageDiscount) {
    messageDiscountTag = (
      <div className={`${messageDiscount.type_class}`}>
        <i className={`${messageDiscount.class_icon} pl-2`}></i>
        <span>{messageDiscount.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (!discount) {
      return;
    }

    let newPriceEachDay = 0;
    if (discount.type.toUpperCase() == typeAmount.typeAmountString.PERCENT) {
      newPriceEachDay = Math.floor(
        Math.floor(priceEachDay * (100 - discount.amount)) / 100
      );
    } else if (
      discount.type.toUpperCase() == typeAmount.typeAmountString.PRICE
    ) {
      newPriceEachDay = Math.floor(priceEachDay - discount.amount);
    }

    setPriceEachDayWithDiscount(newPriceEachDay);
  }, [discount]);

  const getCategoriesUserSitesPublisher = async () => {
    let categories = await sendRequestGetCategoriesUserSitesPublisher();
    if (categories === false) {
      return;
    }
    setTagCategories(generateTagCategories(categories));
  };

  useEffect(() => {
    getCategoriesUserSitesPublisher();
  }, []);

  useEffect(() => {
    if (categorySelected === null) {
      return;
    }
    setCampaignDays(calculateDays());
    setPriceEachDay(categorySelected.amount);
    setCountPositions(categorySelected.count_positions);
  }, [categorySelected]);

  useEffect(() => {
    if (categorySelected === null) {
      return;
    }
    setCampaignPrice(campaignDays * priceEachDay);
  }, [priceEachDay]);

  useEffect(() => {
    if (categorySelected === null) {
      return;
    }
    setCampaignPriceWithDiscount(campaignDays * priceEachDayWithDiscount);
  }, [priceEachDayWithDiscount]);

  useEffect(() => {
    if (categorySelected === null) {
      return;
    }
    setCampaignDepositPrice(
      Math.floor(campaignPrice / process.env.REACT_APP_DEPOSIT_COEFFICIENT)
    );
  }, [campaignPrice]);

  useEffect(() => {
    if (categorySelected === null) {
      return;
    }
    setCampaignDepositPriceWithDiscount(
      Math.floor(
        campaignPriceWithDiscount / process.env.REACT_APP_DEPOSIT_COEFFICIENT
      )
    );
  }, [campaignPriceWithDiscount]);

  const generateTagCategories = (categories) => {
    return categories.map((category) => {
      return (
        <>
          <option key={category.id} value={category.id}>
            {category.name}
          </option>
        </>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetCategoriesUserSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/add-campaign/1",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return categoryAllPublisher.data.data;
  };

  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "نوع کمپین بنری",
      status: true,
      link: "/campaigns/all-type-banner",
    },
    {
      title: "گروه نمایش دهنده بنری",
      status: true,
      link: "/campaigns/banner/simple/add-group-site-publisher",
    },
    {
      title: "کمپین بنری",
      status: true,
      link: "/campaigns/banner/simple/add",
    },
    {
      title: "تبلیغ بنری",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];

  const sendForm = async (e) => {
    e.preventDefault();

    const dataForm = getFormData();

    if (validateFormAddCampaign(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormAddCampaign(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    if (!checkChargeMoreThanTotalAmountCampaign()) {
      setMessage({
        type_class: "alert alert-danger",
        text: messagesCampaignBannerSimple.CHARGE_LESS_THAN_TOTAL_AMOUNT_CAMPAIGN,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    const resultSendRequestAddCampaign = await sendRequestAddCampaign(dataForm);
    if (resultSendRequestAddCampaign) {
      history.push(
        `/advertise/banner/add/${resultSendRequestAddCampaign.campaign_id}`
      );
    }
  };

  const scrollForSeeMessage = () => {
    const element = document.getElementById("container-steps-add-campaigns");
    element.scrollIntoView();
  };

  const checkChargeMoreThanTotalAmountCampaign = () => {
    let totalAmountCampaign = campaignPrice + campaignDepositPrice;
    if (discount) {
      totalAmountCampaign =
        campaignPriceWithDiscount + campaignDepositPriceWithDiscount;
    }
    if (charge > totalAmountCampaign) {
      return true;
    }

    return false;
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const getFormData = () => {
    return {
      name: document.querySelector("#name-campaign").value.trim(),
      category_id: document.querySelector("#category-campaign").value,
      discount_title: document.querySelector("#discount-title").value,
    };
  };

  const sendRequestAddCampaign = async (campaignData) => {
    const headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultPostRequest;
    try {
      resultPostRequest = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/campaign/banner/simple",
        campaignData,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("add-campaign-user");
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    return resultPostRequest.data.data;
  };

  const selectCategorySitePublisher = async (e) => {
    e.preventDefault();
    const categoryID = parseInt(e.target.value);
    if (!Number.isInteger(categoryID)) {
      return;
    }
    getCategorySitePublisherData(categoryID);
    checkFillPosition(categoryID);
  };

  const checkFillPosition = async (categoryID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultCheckFillPosition = await sendRequestCheckFillPosition(
      categoryID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultCheckFillPosition) {
      return;
    }

    setFillPositions(resultCheckFillPosition.fillPositions);
  };

  const sendRequestCheckFillPosition = async (categoryID) => {
    const headersRequest = getHeaderForRequest();
    let checkFillPosition;
    try {
      checkFillPosition = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/check-reserve-positions/category-user-site-publisher/" +
          categoryID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return checkFillPosition.data.data;
  };

  const getCategorySitePublisherData = async (categoryID) => {
    const categorySitePublisherData =
      await sendRequestGetCategorySitePublisherData(categoryID);
    if (!categorySitePublisherData) {
      return;
    }
    setCategorySelected(categorySitePublisherData);
  };

  const sendRequestGetCategorySitePublisherData = async (categoryID) => {
    const headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let categorySitePublisherData;
    try {
      categorySitePublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          categoryID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return categorySitePublisherData.data.data;
  };

  const calculateDays = () => {
    const startDate = moment(categorySelected.start_date);
    const endDate = moment(categorySelected.end_date);
    return endDate.diff(startDate, "days") + 1;
  };

  const checkDiscount = async () => {
    const discountTitle = document
      .querySelector("#discount-title")
      .value.trim();

    const discount = await sendRequestCheckDiscount(
      discountTitle,
      categorySelected.id
    );
    if (!discount) {
      return;
    }
    setDiscount(discount);

    const textMessage = `
    کد تخفیف   
     ${helperNumber.toPersianNum(
       helperNumber.toFormatFinanceNumber(discount.amount)
     )}

    ${
      discount.type.toUpperCase() == typeAmount.typeAmountString.PRICE
        ? "تومانی"
        : ""
    }
    ${
      discount.type.toUpperCase() == typeAmount.typeAmountString.PERCENT
        ? "درصدی"
        : ""
    }
     شما اعمال شد. ‍‍‍‍‍‍‍‍‍‍‍
    برای تایید نهایی کد تخفیف دکمه درج کمپین کلیک کنید. 
    `;
    setMessageDiscount({
      type_class: "alert alert-success",
      text: textMessage,
      class_icon: "fa fa-info",
    });
  };

  const sendRequestCheckDiscount = async (
    discountTitle,
    categorySelectedID
  ) => {
    const headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let discount;
    try {
      discount = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/discount/banner/check/",
        {
          title: discountTitle,
          category_user_site_publisher_ID: categorySelectedID + "",
        },
        headersRequest
      );
    } catch (error) {
      setMessageDiscount({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return discount.data.data;
  };

  const generateTableInfoCampaign = () => {
    return (
      <div className="table-responsive ">
        <table className="table table-hilite tbl-td-white-space ">
          <thead>
            <tr>
              <td
                colSpan={2}
                className="text-center"
                style={{ borderRadius: "25px 25px 0 0" }}
              >
                <b>اطلاعات کمپین</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>تاریخ شروع</td>
              <td>
                <span className="number-finance">
                  {categorySelected?.start_date ? (
                    <label className="pl-1">
                      {helperNumber.toPersianNum("00:00")}
                    </label>
                  ) : (
                    <></>
                  )}
                  <label className="pr-2">
                    {categorySelected?.start_date ? (
                      helperNumber.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          categorySelected?.start_date
                        )
                      )
                    ) : (
                      <></>
                    )}
                  </label>
                </span>
              </td>
            </tr>
            <tr>
              <td>تاریخ پایان</td>
              <td>
                <span className="number-finance">
                  {categorySelected?.end_date ? (
                    <label className="pl-1">
                      {helperNumber.toPersianNum("23:59")}
                    </label>
                  ) : (
                    <></>
                  )}
                  <label className="pr-2">
                    {categorySelected?.end_date ? (
                      helperNumber.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          categorySelected?.end_date
                        )
                      )
                    ) : (
                      <></>
                    )}
                  </label>
                </span>
              </td>
            </tr>
            <tr>
              <td>تعداد جایگاه</td>
              <td>
                <label>
                  {helperNumber.toPersianNum(
                    helperNumber.toFormatFinanceNumber(countPositions)
                  )}
                </label>
              </td>
            </tr>
            <tr>
              <td>مبلغ یک شبانه روز کمپین </td>
              <td>
                <span>
                  <span>
                    <label
                      className={`letter-spacing-finance-number  
                                ${
                                  discount ? "text-decoration-line-through" : ""
                                } `}
                    >
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(priceEachDay)
                      )}
                    </label>
                    <label
                      className={`pr-2
                                ${
                                  discount ? "text-decoration-line-through" : ""
                                } `}
                    >
                      تومان
                    </label>
                  </span>
                  <span
                    className={`pr-2 text-danger ${!discount ? "d-none" : ""} `}
                  >
                    <label className="letter-spacing-finance-number ">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(
                          priceEachDayWithDiscount
                        )
                      )}
                    </label>
                    <label className="pr-2">تومان</label>
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td>مبلغی که در هر ساعت کسر میشود</td>
              <td>
                <span>
                  <label
                    className={`letter-spacing-finance-number  
                              ${
                                discount ? "text-decoration-line-through" : ""
                              } `}
                  >
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        Math.floor(priceEachDay / 24)
                      )
                    )}
                  </label>
                  <label
                    className={`pr-2
                              ${
                                discount ? "text-decoration-line-through" : ""
                              } `}
                  >
                    {" "}
                    تومان
                  </label>
                </span>
                <span
                  className={`pr-2 text-danger ${!discount ? "d-none" : ""} `}
                >
                  <label className="letter-spacing-finance-number ">
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        Math.floor(priceEachDayWithDiscount / 24)
                      )
                    )}
                  </label>
                  <label className="pr-2">تومان</label>
                </span>
              </td>
            </tr>

            <tr>
              <td>تعداد شبانه روز کمپین</td>
              <td>
                <span>
                  <label>{helperNumber.toPersianNum(campaignDays)}</label>
                  <label className="pr-2">شبانه روز</label>
                </span>
              </td>
            </tr>

            <tr>
              <td>مبلغ کمپین</td>
              <td>
                <span>
                  <label
                    className={`letter-spacing-finance-number  
                                ${
                                  discount ? "text-decoration-line-through" : ""
                                } `}
                  >
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(campaignPrice)
                    )}
                  </label>
                  <label
                    className={`pr-2
                               ${
                                 discount ? "text-decoration-line-through" : ""
                               } `}
                  >
                    تومان
                  </label>
                </span>
                <span
                  className={`pr-2 text-danger ${!discount ? "d-none" : ""} `}
                >
                  <label className="letter-spacing-finance-number">
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        campaignPriceWithDiscount
                      )
                    )}
                  </label>
                  <label className="pr-2"> تومان</label>
                </span>
              </td>
            </tr>

            <tr>
              <td>مبلغ بیعانه کمپین </td>
              <td>
                <span>
                  <label
                    className={`letter-spacing-finance-number  
                               ${
                                 discount ? "text-decoration-line-through" : ""
                               } `}
                  >
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(campaignDepositPrice)
                    )}
                  </label>
                  <label
                    className={`pr-2
                               ${
                                 discount ? "text-decoration-line-through" : ""
                               } `}
                  >
                    {" "}
                    تومان
                  </label>
                </span>
                <span
                  className={`pr-2 text-danger ${!discount ? "d-none" : ""} `}
                >
                  <label className="letter-spacing-finance-number">
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        campaignDepositPriceWithDiscount
                      )
                    )}
                  </label>
                  <label className="pr-2"> تومان</label>
                </span>
              </td>
            </tr>
            <tr>
              <td>مبلغ کل کمپین</td>
              <td>
                <span>
                  <label
                    className={`letter-spacing-finance-number  
                               ${
                                 discount ? "text-decoration-line-through" : ""
                               } `}
                  >
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        campaignDepositPrice + campaignPrice
                      )
                    )}
                  </label>
                  <label
                    className={`pr-2
                              ${
                                discount ? "text-decoration-line-through" : ""
                              } `}
                  >
                    {" "}
                    تومان
                  </label>
                </span>

                <span
                  className={`pr-2 text-danger ${!discount ? "d-none" : ""} `}
                >
                  <label className="letter-spacing-finance-number">
                    {helperNumber.toPersianNum(
                      helperNumber.toFormatFinanceNumber(
                        campaignDepositPriceWithDiscount +
                          campaignPriceWithDiscount
                      )
                    )}
                  </label>
                  <label className="pr-2"> تومان</label>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تنظیمات نمایش کمپین بنری موضوعی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      اگر تاریخ شروع گروه نمایش دهنده شما برابر یا قبل از تاریخ
                      امروز باشد در بخش گروه نمایش دهندگان زیر نمایش داده
                      نمیشود.{" "}
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      هر گروه نمایش دهنده فقط میتواند به یک کمپین اختصاص داده
                      شود.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      مبلغ بیعانه ابتدا درج کمپین از موجودی حساب شما کسر خواهد
                      شد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      %۳۳ مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان
                      بیعانه در زمان درج کمپین از موجودی حساب شما کسر میگردد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما
                      بازگردانده خواهد شد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما
                      بازگشت داده نخواهد شد.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 ">
                    <div id="add-campaign-user"></div>
                    {messageTag}
                    <form onSubmit={sendForm}>
                      <div className="col-12 col-md-6  ">
                        <label>نام کمپین</label>
                        <input
                          className="form-control"
                          id="name-campaign"
                          type="text"
                        />
                      </div>

                      <div className="col-12 col-md-6 py-4 ">
                        <label>گروه سایت های نمایش دهنده بنری</label>
                        <select
                          id="category-campaign"
                          className="form-control"
                          onChange={selectCategorySitePublisher}
                        >
                          <option>انتخاب کنید</option>
                          {tagCategories}
                        </select>
                      </div>

                      {fillPositions.length > 0 && (
                        <div className="alert alert-danger ">
                          <p className="text-justify">
                            <i className="fa fa-info pl-2"></i>
                            توجه داشته باشید :{" "}
                          </p>
                          <ul className="pr-3">
                            <li>
                              <p className="text-justify">
                                جایگاه های زیر از قبل انتخاب شده و قابلیت اجرا
                                کمپین در آنها وجود ندارد.شما می توانید از طریق
                                بخش
                                <Link
                                  className="px-2"
                                  target="_blank"
                                  to={`/publishers/edit-group/banner/${categorySelected.id}`}
                                >
                                  ویرایش
                                </Link>
                                گروه های نمایش دهنده جایگاه های زیر از گروه
                                نمایش دهنده خود حذف کنید یا یک گروه نمایش دهنده
                                <Link
                                  className="px-2"
                                  target="_blank"
                                  to="/publishers/add-group/banner"
                                >
                                  جدید
                                </Link>
                                بسازید که در آن این جایگاه ها وجود ندارد.
                              </p>
                            </li>
                            <li>
                              <p>
                                {fillPositions.map((position) => {
                                  return (
                                    <>
                                      <span className="px-2">{position}</span>-
                                    </>
                                  );
                                })}
                              </p>
                            </li>
                          </ul>
                        </div>
                      )}
                      {categorySelected !== undefined ? (
                        generateTableInfoCampaign()
                      ) : (
                        <></>
                      )}

                      {fillPositions.length == 0 && (
                        <>
                          <div className="col-12 col-md-6 pt-2 ">
                            <div className="input-group mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="discount-title"
                                disabled={
                                  categorySelected == null ? true : false
                                }
                                placeholder="کد تخفیف خود را وارد کنید."
                              />
                              <div className="input-group-append">
                                <button
                                  className="btn btn-info rounded"
                                  type="button"
                                  disabled={
                                    categorySelected != null && discount == null
                                      ? false
                                      : true
                                  }
                                  onClick={(e) => {
                                    e.preventDefault();
                                    checkDiscount();
                                  }}
                                >
                                  اعمال کد تخفیف
                                </button>
                                <button
                                  className="btn btn-info"
                                  disabled={
                                    !categorySelected || !discount
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setDiscount(null);
                                    setMessageDiscount();
                                    document.querySelector(
                                      "#discount-title"
                                    ).value = "";
                                  }}
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </div>
                              <div className="pt-2 w-100">
                                {messageDiscountTag}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center pr-2">
                            <span className="d-flex align-items-center pl-2">
                              <input
                                className="hover"
                                onChange={() => {
                                  setDisableAddCampaignButton((preState) => {
                                    return !preState;
                                  });
                                }}
                                disabled={
                                  categorySelected == null ? true : false
                                }
                                type="checkbox"
                              />
                            </span>
                            <span>شرایط را می پذیرم</span>
                          </div>

                          <div className="col-12 col-md-6 pt-2 ">
                            <button
                              disabled={disableAddCampaignButton}
                              type="submit"
                              className="btn btn-primary"
                            >
                              درج کمپین
                            </button>
                          </div>
                        </>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    charge: state.main.charge,
  };
};
export default connect(mapStateToProps, null)(AddBannerSimpleCampaign);
